import React, {useCallback, useMemo, useState} from 'react'
import {Headers, Sort, SortKeys, SortOrder} from '../../types'
import {Post} from '../../../../../../setup'
import {useMailing} from '../../../../../../app/@types'
import {Subscriber} from '../../../../../../app/pages/mailing/contacts/types'
import {THead} from '../../components/THead'
import {paginate} from '../../../../content/pagination/types'
import {Pagination} from '../../../../content/pagination/Pagination'
import {ActionsButton} from '../../components/ActionsButtons'
import {SelectAll} from '../../../../../../app/@components'
import {Search} from '../../../../content/forms'
import {SearchedData} from '../../../../../../app/features'
import {useFormik} from 'formik'
import {KTSVG} from '../../../../../helpers'
import {ContactRowShow, ContactRowUpdate} from '../../../../../../app/pages/mailing'

const headers: Headers<Subscriber>[] = [
  {key: 'created_at', label: 'Date', className: 'fw-bolder text-muted bg-light min-w-200px'},
  {key: 'email', label: 'E-mail', className: 'fw-bolder text-muted bg-light min-w-200px'},
  {key: 'last_name', label: 'Nom', className: 'fw-bolder text-muted bg-light min-w-150px'},
  {key: 'first_name', label: 'Prénom', className: 'fw-bolder text-muted bg-light min-w-150px'},
  {key: 'unsubscribed_at', label: 'Statut', className: 'fw-bolder text-muted bg-light min-w-125px'},
]

const REMOVE_CONTACTS = process.env.REACT_APP_MAILING_REMOVE_CONTACTS_FROM_LIST || 'v2/subscribers-delete-list-contact'
const UPDATE_SUBSCRIPTION_CONTACTS = process.env.REACT_APP_MAILING_UPDATE_SUBSCRIPTION_CONTACTS || 'v2/subscribers-abonne-desabonne'

type handleRemoveType = {ids: number[]}
type filterStatusType = "ALL" | "SUBSCRIBE" | "UNSUBSCRIBE"

const initialValuesSubscribersStatus = {
  isSubscribe: '1',
}



const TablesWidget23 = ({data}: {data: Subscriber[] | []}) => {

  const {triggerReload} = useMailing()
  const [sortKey, setSortKey] = useState<SortKeys<Subscriber>>('created_at')
  const [sortOrder, setSortOrder] = useState<SortOrder>('desc')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [selectedItems, setSelectedItems] = useState<number[]>([])
  const [selectAll, setSelectAll] = useState<boolean>(false)
  const [searchQuery, setSearchQuery] = useState<string>('')
  const [loadingChangeSubscribersStatus, setLoadingChangeSubscribersStatus] = useState(false)
  const [editingRow, setEditingRow] = useState<number>(-1)
  const [filterStatus, setFilterStatus] = useState<filterStatusType>('ALL');

  const dataSorted: Subscriber[] = useMemo(() => {
    return Sort<Subscriber>({data, sortKey, reverse: sortOrder === 'desc'})
  }, [data, sortKey, sortOrder])

  const filteredData = useMemo(() => {
    let dataFilteredBySearch = SearchedData<Subscriber>(dataSorted, searchQuery)
    if (filterStatus === "SUBSCRIBE") return dataFilteredBySearch.filter(subscriber => !subscriber.unsubscribed_at)
    else if (filterStatus === "UNSUBSCRIBE") return dataFilteredBySearch.filter(subscriber => subscriber.unsubscribed_at)

    return dataFilteredBySearch
  }, [dataSorted, filterStatus, searchQuery])

  const paginateData = useMemo(
    () => paginate<Subscriber>({currentPage, itemsPerPage, data: filteredData}),
    [currentPage, itemsPerPage, filteredData],
  )

  const handleCheckboxChange = (id: number) => {

    let updatedSelectedItems
    if (selectedItems.includes(id)) {
      updatedSelectedItems = selectedItems.filter(itemId => itemId !== id)
    } else {
      updatedSelectedItems = [...selectedItems, id]
    }
    setSelectedItems(updatedSelectedItems)
    setSelectAll(updatedSelectedItems.length === paginateData.length)
  }

  const handleRemove = useCallback(async ({ids}: handleRemoveType) => {

    const data = {subscribers: {ids}}
    try {
      await Post<any>(REMOVE_CONTACTS, data)
      triggerReload()
      setSelectedItems([])
    } catch (e) {
      console.log(e)
    }

  }, [triggerReload])
  const onSubmitSubscribersStatus = async (values: typeof initialValuesSubscribersStatus, {setSubmitting}: {
    setSubmitting: (isSubmitting: boolean) => void
  }) => {

    setLoadingChangeSubscribersStatus(true)

    try {
      const fomValues = {...values, ids: selectedItems}
      const {status} = await Post<any>(UPDATE_SUBSCRIPTION_CONTACTS, fomValues)
      if (status === 200) {
        triggerReload()
        setSelectedItems([])
      }
    } catch (e) {
      console.log(e)
    } finally {
      setLoadingChangeSubscribersStatus(false)
    }

  }

  const formikChangeSubscribersStatus = useFormik({
    initialValues: initialValuesSubscribersStatus,
    enableReinitialize: true,
    onSubmit: onSubmitSubscribersStatus,
  })

  const handleEditClick = (id: number) => {
    setEditingRow(id)
  }

  return (
    <>
      <div className="row d-flex justify-content-between align-items-center mb-5">
        <div className="col-12 col-md-6 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center flex-row">
            <div className="d-flex align-items-center flex-row me-5">
              <SelectAll selectAll={selectAll}
                         setSelectAll={setSelectAll}
                         setSelectedItems={setSelectedItems}
                         data={paginateData}
              />

              <ActionsButton tooltip="Supprimer"
                             iconPath="/media/icons/duotune/general/gen027.svg"
                             iconClass="svg-icon-2 svg-icon-danger"
                             className="btn btn-sm btn-icon btn-active-light-danger"
                             onClick={() => handleRemove({ids: selectedItems})}
                             disabled={!selectedItems.length}
              />
            </div>
            <div>
              <form onSubmit={formikChangeSubscribersStatus.handleSubmit} noValidate className="form d-flex">
                <select className="form-select form-select-solid form-select-sm me-1"
                        {...formikChangeSubscribersStatus.getFieldProps('isSubscribe')}
                        disabled={!selectedItems.length}
                >
                  <option value="1">Abonné</option>
                  <option value="0">Désabonné</option>
                </select>

                {
                  !!selectedItems.length && (
                    <button className="btn btn-sm btn-icon btn-light-primary"
                            type="submit"
                    >
                      {!loadingChangeSubscribersStatus &&
                        <KTSVG path="/media/icons/duotune/general/gen037.svg" className="svg-icon-2 svg-icon-primary" />}
                      {loadingChangeSubscribersStatus && (
                        <span className="indicator-progress" style={{display: 'block'}}>
                              <span className="spinner-border spinner-border-sm align-middle" />
                          </span>
                      )}
                    </button>
                  )
                }

              </form>
            </div>
          </div>
          <div className="d-flex justify-content-start align-items-center">
            <select name="" id="" className="form-select form-select-sm form-select-solid"
                    onChange={(e) => setFilterStatus(e.target.value as filterStatusType)}
            >
              <option value="ALL">Tous</option>
              <option value="SUBSCRIBE">Abonnés</option>
              <option value="UNSUBSCRIBE">Désabonnés</option>
            </select>
          </div>
        </div>
        <div className="col-12 col-md-5">
          <Search setSearchInput={setSearchQuery} />
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
          <THead headers={headers}
                 sortKey={sortKey}
                 setSortKey={setSortKey}
                 sortOrder={sortOrder}
                 setSortOrder={setSortOrder}
                 firstChildren={<th className="min-w-50px" />}
                 children={<th className="fw-bolder text-muted text-center bg-light min-w-100px">
              <span className="btn btn-sm text-muted w-auto px-0">
                Actions
              </span>
                 </th>}
          />
          <tbody>
          {
            paginateData.map((item, index) => (
              editingRow !== item.id
                ? <ContactRowShow key={index} item={item} handleEditClick={handleEditClick}
                                  handleCheckboxChange={handleCheckboxChange} selectedItems={selectedItems}
                />
                : <ContactRowUpdate key={index} item={item} handleEditClick={handleEditClick} setEditingRow={setEditingRow} />
            ))
          }
          </tbody>
        </table>
      </div>

      <Pagination itemsPerPage={itemsPerPage}
                  totalItems={filteredData.length}
                  setCurrentPage={setCurrentPage}
                  setItemsPerPage={setItemsPerPage}
      />
    </>
  )
}

export {TablesWidget23}